"use client";

import { useQuery } from "@tanstack/react-query";
import Lottie from "lottie-react";
import { ChevronLeftIcon, ChevronRightIcon, TrendingUpIcon } from "lucide-react";
import { useState } from "react";
import trendingAnimation from "./trending.json";

async function getTrendingNewsData() {
	const TRENDING_NEWS_DATA = {
		data: [
			{
				id: "ccd058be-71fb-45fc-a2eb-fd6a6b81a86b",
				text: `<span><a href="https://www.proptechbuzz.com/news/south-africa-multifamily-residential-property-market-research-report-samrra" target="_blank" rel="nofollow">Unveiling South Africa's Multifamily Residential Property Market Insights | SAMRRA Researchr</a></span>`,
				link: null,
				region: "Africa",
				updatedAt: "2024-06-08T15:01:46.369Z",
			},
			{
				id: "f882a99e-079f-4340-8985-5b91fff59927",
				text: `<span><a href="https://www.proptechbuzz.com/news/realstar-secures-investment-investec-uncle-manchester" target="_blank" rel="nofollow">Realstar Secures €25.7 Million Investment with Investec for UNCLE Manchester</a></span>`,
				link: null,
				region: "Africa",
				updatedAt: "2024-06-07T15:01:46.369Z",
			},
			{
				id: "e100d798-f386-47b2-86a1-5c5c0a696917",
				text: `<span><a href="https://www.proptechbuzz.com/news/global-reborn-group-fundraise-ai-real-estate-tools" target="_blank" rel="nofollow">Global Reborn Group Secures $600M Fund for AI Real Estate Tools</a></span>`,
				link: null,
				region: "Africa",
				updatedAt: "2024-06-07T15:01:46.369Z",
			},
			{
				id: "e0d9cd1b-9687-4506-ad89-2b237a00c61b",
				text: `<span><a href="https://www.proptechbuzz.com/news/prop-tech-platform-estate-agents" target="_blank" rel="nofollow">New PropTech Platform Simplifies CRM Integration for Estate Agents</a></span>`,
				link: null,
				region: "Africa",
				updatedAt: "2024-06-07T15:01:46.369Z",
			},
			{
				id: "25eaadc8-f2e6-46be-af24-562652162ac1",
				text: `<span><a href="https://www.proptechbuzz.com/news/ishack-ventures-mri-software-integration" target="_blank" rel="nofollow">iShack Ventures Partners with MRI Software for Enhanced Property Management Solutions</a></span>`,
				link: null,
				region: "Africa",
				updatedAt: "2024-06-07T15:01:46.369Z",
			},
			{
				id: "9794e270-375c-4794-a021-0a5267402159",
				text: `<span><a href="https://www.proptechbuzz.com/news/xchange-mls-platform-launches-at-arce-2024-charting-new-frontiers-for-african-proptech" target="_blank" rel="nofollow">Xchange MLS Platform Launches at ARCE 2024, Charting New Frontiers for African Proptech</a></span>`,
				link: null,
				region: "Africa",
				updatedAt: "2024-06-07T15:01:46.369Z",
			},
			{
				id: "b8670142-b852-41b3-bd48-804b2b8334ce",
				text: `<span><a href="https://www.proptechbuzz.com/news/cape-town-proptech-launchbase" target="_blank" rel="nofollow">Cape Town's LaunchBase Revolutionizes Property Sales with PropTech Solutions</a></span>`,
				link: null,
				region: "Africa",
				updatedAt: "2024-06-07T15:01:46.369Z",
			},
			{
				id: "087fdd48-c2f3-4e8a-8481-8e8d360e553d",
				text: `<span><a href="https://www.proptechbuzz.com/news/prop-tech-platform-estate-agents" target="_blank" rel="nofollow">New PropTech Platform Simplifies CRM Integration for Estate Agents</a></span>`,
				link: null,
				region: "Africa",
				updatedAt: "2024-06-07T14:47:40.488Z",
			},
			{
				id: "4f6b7d8c-1e2f-4e7d-8f6b-1e2f4e7d8f6",
				text: `<span><a href="https://substack.com/redirect/b7b8a422-4ef7-4c33-b171-cf30dd53e866?j=eyJ1IjoiMmw2Mm4zIn0.mOdUtyzeLFuVLaCjlPo80FJ1m656U1HfuaN4HlOXp-U" target="_blank" rel="nofollow">reAlpha has 'wild first week' after IPO. (Bloomberg)</a></span>`,
				link: null,
				region: "Global",
				updatedAt: "2023-11-07T11:52:09.709Z",
			},
			{
				id: "5b7a9c8d-2e4f-4d5e-8b7a-2e4f4d5e8b7a",
				text: `<span><a href="https://substack.com/redirect/735fc3e8-fc25-478d-a2ba-96e9693f4cb3?j=eyJ1IjoiMmw2Mm4zIn0.mOdUtyzeLFuVLaCjlPo80FJ1m656U1HfuaN4HlOXp-U" target="_blank" rel="nofollow">Zillow acquired CRM Follow Up Boss.</a></span>`,
				link: null,
				region: "Global",
				updatedAt: "2023-11-07T11:52:09.709Z",
			},
			{
				id: "8d4c5b7a-3f2e-4b7f-8c5b-3f2e4b7f8c5b",
				text: `<span><a href="https://substack.com/redirect/5fe3bddc-5911-4463-a508-2c85a135fe52?j=eyJ1IjoiMmw2Mm4zIn0.mOdUtyzeLFuVLaCjlPo80FJ1m656U1HfuaN4HlOXp-U" target="_blank" rel="nofollow">Payapps raised to fund acquisition of UK's WebContractor.</a></span>`,
				link: null,
				region: "Global",
				updatedAt: "2023-11-07T11:52:09.709Z",
			},
			{
				id: "7f3c5d6e-8b1a-4b6f-8c5d-8b1a4b6f8c5",
				text: `<span><a href="https://substack.com/redirect/61c48356-00c6-4ac5-9e99-42839dea021e?j=eyJ1IjoiMmw2Mm4zIn0.mOdUtyzeLFuVLaCjlPo80FJ1m656U1HfuaN4HlOXp-U" target="_blank" rel="nofollow">UK Gov announced creation of PropTech Steering Board.</a></span>`,
				link: null,
				region: "Global",
				updatedAt: "2023-11-07T11:52:09.709Z",
			},
			{
				id: "6e1d8f7b-3c5a-4d6e-8a7f-3c5a4d6e8a7",
				text: `<span><a href="https://substack.com/redirect/cd0b459a-d91e-4b85-8f59-60b2d678ebf7?j=eyJ1IjoiMmw2Mm4zIn0.mOdUtyzeLFuVLaCjlPo80FJ1m656U1HfuaN4HlOXp-U" target="_blank" rel="nofollow">White House opens $45B to convert offices into homes.</a></span>`,
				link: null,
				region: "Global",
				updatedAt: "2023-11-07T11:52:09.709Z",
			},
			{
				id: "2e8b7f4c-6d5a-4f2d-8b7f-6d5a4f2d8b7",
				text: `<span><a href="https://substack.com/redirect/a16f1b7b-c9aa-424d-a949-3912961e4407?j=eyJ1IjoiMmw2Mm4zIn0.mOdUtyzeLFuVLaCjlPo80FJ1m656U1HfuaN4HlOXp-U" target="_blank" rel="nofollow">WeWork was reported to plan to declare bankruptcy.</a></span>`,
				link: null,
				region: "Global",
				updatedAt: "2023-11-07T11:52:09.709Z",
			},
			{
				id: "asdewadwd",
				text: `<span>Here Are The Six Startups That Made It To Gruhas <a href="https://inc42.com/buzz/here-are-the-six-startups-that-made-it-to-gruhas-aspires-second-proptech-cohort/" target="_blank" rel="nofollow">ASPIRE's Second Proptech Cohort</a></span>`,
				link: null,
				region: "India & Middle East",
				updatedAt: "2023-10-09T10:21:54.658Z",
			},
			{
				id: "efdsefefrfrgg",
				text: `<span>Property Finder brings together <a href="https://www.zawya.com/en/press-release/companies-news/property-finder-brings-together-egypts-real-estate-industry-leaders-at-the-first-ever-property-finder-connect-2023-in-the-country-augr3az1" target="_blank" rel="nofollow">Egypt's real estate industry leaders</a></span>`,
				link: null,
				region: "India & Middle East",
				updatedAt: "2023-10-09T10:21:54.658Z",
			},
			{
				id: "aewrdefsdfw",
				text: `<span>Demand for <a href="https://www.gulftoday.ae/business/2023/10/04/demand-for-automation-tools-up-as-uae-net-zero-vision-on-track" target="_blank" rel="nofollow">building automation tools up as UAE's Net Zero vision on track</a></span>`,
				link: null,
				region: "India & Middle East",
				updatedAt: "2023-10-09T10:21:54.658Z",
			},
			{
				id: "sdbjndsjnd",
				text: `<span>Retail space launches at <a href="https://www.insidermedia.com/news/north-west/retail-space-launches-at-25m-business-park" target="_blank" rel="nofollow">£25m business park</a></span>`,
				link: null,
				region: "Europe & UK",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
			{
				id: "dsvljnsvdksd",
				text: `<span>Casa by Moda secures funding to build <a href="https://www.housingtoday.co.uk/news/casa-by-moda-secures-funding-to-build-1100-rented-homes/5125344.article" target="_blank" rel="nofollow">1,100 rented homes</a></span>`,
				link: null,
				region: "Europe & UK",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
			{
				id: "pdkdjchdmd",
				text: `<span><a href="https://primeresi.com/how-artificial-intelligence-is-reshaping-the-uk-property-industry/" target="_blank" rel="nofollow">How Artificial Intelligence is reshaping the UK property industry</a></span>`,
				link: null,
				region: "Europe & UK",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
			{
				id: "vncbdhdn",
				text: `<span>Demand for <a href="https://www.gulftoday.ae/business/2023/10/04/demand-for-automation-tools-up-as-uae-net-zero-vision-on-track" target="_blank" rel="nofollow">building automation tools up as UAE's Net Zero vision on track</a></span>`,
				link: null,
				region: "Africa",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
			{
				id: "dccddvsvs",
				text: `<span>Property Finder brings <a href="https://www.zawya.com/en/press-release/companies-news/property-finder-brings-together-egypts-real-estate-industry-leaders-at-the-first-ever-property-finder-connect-2023-in-the-country-augr3az1" target="_blank" rel="nofollow"></a>together Egypt's real estate industry leaders</span>`,
				link: null,
				region: "Africa",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
			{
				id: "thbged",
				text: `<span>Here Are <a href="https://inc42.com/buzz/here-are-the-six-startups-that-made-it-to-gruhas-aspires-second-proptech-cohort/" target="_blank" rel="nofollow">The Six Startups That Made It To Gruhas ASPIRE's Second Proptech Cohort</a></span>`,
				link: "",
				region: "Africa",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
			{
				id: "vswxwfd",
				text: `<span>Pioneering a Legacy: <a href="http://prop.com/" target="_blank" rel="nofollow">Prop.com's</a></span>`,
				link: null,
				region: "Africa",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
			{
				id: "bvddcccd",
				text: `<span><a href="https://ventureburn.com/2023/10/africa-proptech-forum-to-pioneer-innovation-in-real-estate/" target="_blank" rel="nofollow">Africa Proptech Forum to pioneer innovation in real estate</a></span>`,
				link: null,
				region: "Africa",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
			{
				id: "bsdvde",
				text: `<span><a href="https://www.sfchronicle.com/sf/article/real-estate-brookfield-apartment-deal-18383188.php" target="_blank" rel="nofollow">This real estate giant gave up S.F.'s Westfield mall. Now it may fund an $800 million apartment deal</a></span>`,
				link: null,
				region: "North America",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
			{
				id: "gthbed",
				text: `<span><a href="https://www.yorkregion.com/news/real-estate-prices-in-9-york-region-cities-and-towns-since-2013/article_452c8c0c-b08e-5c25-b481-d66c769d5e1b.html" target="_blank" rel="nofollow">Real estate prices in 9 York Region cities and towns since 2013</a></span>`,
				link: "",
				region: "North America",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
			{
				id: "pkyhqs",
				text: `<span>Orlando commissioners unanimously OK <a href="https://www.orlandosentinel.com/2023/09/25/orlando-commissioners-unanimously-ok-1-77-billion-budget/" target="_blank" rel="nofollow">$1.77 billion budget</a></span>`,
				link: "",
				region: "North America",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
			{
				id: "rgthnb",
				text: `<span>Poilievre taunts CBC, hints at turning <a href="https://tnc.news/2023/09/25/poilievre-taunts-cbc/" target="_blank" rel="nofollow">$400M in real estate into housing</a></span>`,
				link: "",
				region: "North America",
				updatedAt: "2023-09-30T22:06:03.318Z",
			},
		],
	};

	const { data } = TRENDING_NEWS_DATA;
	return Array.isArray(data) ? data.filter(Boolean) : [];
}

export const TrendingNewsCard = () => {
	const [currentRegionIndex, setCurrentRegionIndex] = useState(0);
	const {
		isLoading,
		isError,
		data: trendingNews = [],
	} = useQuery({
		queryKey: ["trendingNews"],
		queryFn: getTrendingNewsData,
		refetchOnWindowFocus: false,
	});

	if (isLoading) {
		return (
			<div className="relative rounded-lg bg-white">
				<div className="flex items-center justify-center py-24">
					<p className="text-sm text-gray-600">Loading trending news...</p>
				</div>
			</div>
		);
	}

	const regions = (Array.isArray(trendingNews) ? trendingNews : [])
		.filter(Boolean)
		.map((news) => news.region);
	const uniqueRegions = Array.from(new Set(regions));

	function sortGlobalToFirst(a: string | null, b: string | null) {
		if (a === "Global") {
			return -1;
		} else if (b === "Global") {
			return 1;
		} else {
			return 0;
		}
	}

	uniqueRegions.sort(sortGlobalToFirst);

	const currentTrendingNews = Array.isArray(trendingNews)
		? trendingNews.filter((news) => news && news.region === uniqueRegions[currentRegionIndex])
		: [];

	const handleShowPreviousPageNews = () => {
		if (currentRegionIndex > 0) {
			setCurrentRegionIndex((prev) => prev - 1);
		} else {
			setCurrentRegionIndex(uniqueRegions.length - 1);
		}
	};

	const handleShowNextPageNews = () => {
		if (currentRegionIndex < uniqueRegions.length - 1) {
			setCurrentRegionIndex((prev) => prev + 1);
		} else {
			setCurrentRegionIndex(0);
		}
	};

	const handleTrackClickEvent = (target_url: string, link_text: string) => {
		window.rudderanalytics?.track("click", {
			target_url,
			link_text,
		});
	};

	return (
		<div className="relative rounded-lg bg-white">
			<div className="flex justify-between p-4">
				<div className="flex items-center gap-1">
					<Lottie animationData={trendingAnimation} loop={true} className="h-6 w-6" />
					<h4 className="font-semibold uppercase text-gray-700">Trending</h4>
				</div>

				<div className="flex items-center gap-1">
					<button onClick={handleShowPreviousPageNews}>
						<ChevronLeftIcon className="h-4 w-4" />
					</button>
					<span className="whitespace-nowrap text-center text-xs">
						{uniqueRegions[currentRegionIndex]}
					</span>

					<button onClick={handleShowNextPageNews}>
						<ChevronRightIcon className="h-4 w-4" />
					</button>
				</div>
			</div>

			<div className="trending-card flex h-36 flex-col overflow-y-scroll">
				{isError ? (
					<div className="mx-4 rounded-md border border-red-500/20 bg-red-500/10 p-4 text-sm font-medium text-red-500">
						Something went wrong while fetching trending news
					</div>
				) : currentTrendingNews?.length > 0 ? (
					currentTrendingNews?.map((news) => (
						<div
							key={news.id}
							className="flex items-center gap-4 border-t border-t-gray-100 px-4 py-3"
						>
							<div>
								<TrendingUpIcon className="h-6 w-6 text-brand-primary" />
							</div>
							<div
								onClick={() =>
									handleTrackClickEvent(news.text ?? "Trending News", news.text ?? "Trending News")
								}
								className="customized-scrollbar trending-text text-xs text-gray-500"
								dangerouslySetInnerHTML={{ __html: news.text ?? "" }}
							/>
						</div>
					))
				) : (
					<div className="mx-4 rounded-md border border-brand-primary/20 bg-brand-primary/10 p-4 text-sm font-medium text-brand-primary">
						No news to show
					</div>
				)}
			</div>
		</div>
	);
};
